import { gananciaApi } from '../../utils/api';
import {
  getObjectDataAction,
  createObjectDataPending,
  getListDataAction,
  saveObjectDataAction,
  deleteObjectDataAction,
  getListDeletedDataAction,
  createListDataDeletedPending,
  restoreObjectDataAction,
  getListByParentDataAction,
} from '../../utils/DataAction';

export const get = (id) =>
  getObjectDataAction({
    dataName: 'GANANCIA',
    api: gananciaApi,
    relUrl: id,
  });
export const getByParent = (id, inversorId) =>
  getObjectDataAction({
    dataName: 'GANANCIA',
    api: gananciaApi,
    relUrl: `indexByParent/${id}/${inversorId}`,
  });

export const getAll = getListDataAction({
  dataName: 'GANANCIA',
  api: gananciaApi,
  relUrl: '',
});

export const getAllByParent = (id) =>
  getListByParentDataAction({
    dataName: 'GANANCIA',
    api: gananciaApi,
    relUrl: `indexByParent/${id}`,
  });

export const save = (data) =>
  saveObjectDataAction({
    dataName: 'GANANCIA',
    api: gananciaApi,
    relUrl: '',
    data: data,
  });

export const deleted = (id) =>
  deleteObjectDataAction({
    dataName: 'GANANCIA',
    api: gananciaApi,
    relUrl: id,
  });

export const getAllDeleted = getListDeletedDataAction({
  dataName: 'GANANCIA',
  api: gananciaApi,
  relUrl: 'restore',
});

export const restore = (data) =>
  restoreObjectDataAction({
    dataName: 'GANANCIA',
    api: gananciaApi,
    relUrl: 'restore',
    data: data,
  });

export const setPending = createObjectDataPending('GANANCIA');
export const setDeletedPending = createListDataDeletedPending('GANANCIA');
